<template lang="pug">
  v-container    
    v-btn.locale-btn(
      text
      small @click="ChangeLocale").indigo--text {{(this.$i18n.locale === 'en')? 'Español' : 'English'}} 
    div.icontainer
      h1.ntitle {{ $t('nufi-subscribe') }}
      v-row 
        v-col(cols="8") {{ $t('nufi-subscribe-text') }}
        v-col(cols="4")
      v-container        
        v-form(
          ref="form"
          v-model="valid"
          )
          v-text-field(
            v-model="customerNUFI.firstName"
            :rules="nameRules"
            :label="$t('name')"
            required)
          v-text-field(
            v-model="customerNUFI.lastName"
            :label="$t('surnames')"
            required)
          v-text-field(
            v-model="customerNUFI.phone"          
            :label="$t('phone')"
            :rules="phoneRules"
            required)
          v-text-field(
            v-model="customerNUFI.email"          
            label="E-mail"
            :rules="emailRules"
            required)
          v-text-field(
            v-model="customerNUFI.note"          
            :label="$t('company')"
            required)
          v-text-field(
            v-model="customerNUFI.password"
            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
            :type="show ? 'text' : 'password'"
            :label="$t('password')"
            :rules="secretRules"
            required
            @click:append="show = !show")
          v-radio-group(
            v-model="paymentMethod"
            @change="paymentMethodChange"
            row)
            v-radio(
              :label="$t('credit-card')"
              value="card")
            v-radio(
              :label="$t('wire-transfer')"
              value="bankTranfer")
          v-container(v-if="paymentMethod === 'card'")
            div(id="card-element")
            div(id="card-result")
          v-container(v-show="paymentMethod === 'bankTranfer'")
            | Nuestro equipo se estará comunicando contigo para autorizar éste método.
            | Si deseas comenzar a utilizar NuFi inmediatamente favor de seleccionar tarjeta de crédito.
          v-container(v-if="message")
            | {{message}}
          v-divider.mb-5.mt-5
          v-progress-linear(
            indeterminate
            :active="loading"
            color="cyan")
          v-container(v-if="!loading")
            v-btn(
              color="primary"
              class="mr-4"
              @click="subscribe"
              ) {{ $t('subscribe') }}
            v-btn(
              color="primary"
              class="mr-4"
              @click="reset"
              ) {{ $t('delete') }}
</template>
<script>
export default {
  data() {
    const vm = this;
    return {
      show: false,
      paymentMethod: "card",
      stripe: null,
      valid: false,
      cardElement: null,
      message: null,
      loading: false,      
      customerNUFI: {
        firstName: "",
        lastName: "",
        phone: "+52",
        email: "",
        confirmation: "signup",
        password: null,
        note: ""
      },
      emailRules: [
        v => !!v || vm.$t("provide-email"),
        v => /.+@.+\..+/.test(v) || vm.$t("provide-email")
      ],
      secretRules: [
        v => !!v || vm.$t("provide-password")
      ],
      nameRules: [
        v => !!v || vm.$t("provide-name")
      ],
      phoneRules: [
        v => !!v || vm.$t("provide-phone"),
        v => /^\+[1-9]{1}[0-9]{8,14}$/.test(v) || vm.$t("provide-phone")
      ]
    }
  },
  mounted() {
    this.stripe = window.Stripe('pk_test_51HJiaJAjczOwzQiTCe3MnYuAnbRjyzEz1o4urAeiudQEO8jJA2RKOcSyoiBWvxIhCiqUdOd6BpyUZ0xPq0ETyUYc00lUyV6QQf');
    const elements = this.stripe.elements();
    this.cardElement = elements.create('card');
    this.cardElement.mount('#card-element');
  },
  methods: {
    subscribeWithCard() {
      const $this = this;
      this.loading = true;
      event.preventDefault();
      window.grecaptcha.ready(function() {        
        window.grecaptcha.execute('6LdLndkZAAAAAGdUjVOMNtsUsM3momBQkRR5yIbO', {action: 'submit'}).then(function(token) {          
          $this.$store.dispatch("verifyCapcha", {token}).then(response => {
            if(response.status === 200) {
              const data = JSON.parse(response.data);
              if(data.success && data.score > .8) {                
                // $this.$store.dispatch("createPaymentMethod", {
                $this.$store.dispatch("createSource", {
                  stripe: $this.stripe,
                  card: $this.cardElement,
                  details: {
                    name: `${$this.customerNUFI.firstName} ${$this.customerNUFI.lastName}`,
                    email: $this.customerNUFI.email,
                    phone: $this.customerNUFI.phone                    
                    }
                  }).then(cmResponse => {                    
                    if (cmResponse.error) {
                      $this.message = cmResponse.error.message;
                      $this.loading = false;
                    } else {                      
                      // $this.message += 'Metodo pago:' + cmResponse.paymentMethod.id;
                      $this.$store.dispatch("createNuFiCustomer", $this.customerNUFI).then(ncResponse => {                        
                        if(ncResponse.status === 200 || ncResponse.status === 201) {                          
                          // $this.message += '***Usuario NuFi' + ncResponse.data.id;
                          const subscriptionName = `NuFi2020-${new Date().getTime()}`;                          
                          $this.$store.dispatch("createNuFiSubscription", {userId:ncResponse.data.id,  name: subscriptionName}).then(nsResponse => {
                            if(nsResponse.status === 200 || nsResponse.status === 201) {
                              // eslint-disable-next-line no-debugger
                        debugger
                              const subscriptionKey = nsResponse.data.properties.primaryKey;
                              $this.$store.dispatch("createStripeCustomer", {
                                name: `${$this.customerNUFI.firstName} ${$this.customerNUFI.lastName}`,
                                email: $this.customerNUFI.email,
                                phone: $this.customerNUFI.phone,
                                //payment_method: cmResponse.paymentMethod.id,
                                source: cmResponse.source.id,
                                metadata: {
                                  subscriptionKey: subscriptionName,
                                  iva: "0.16"
                                },
                              }).then(csResponse => {                                
                                if(csResponse.status === 200) {                                  
                                  $this.$store.dispatch("createSolutionUser", {
                                    name: $this.customerNUFI.firstName,
                                    company: $this.customerNUFI.note,
                                    locale: 'es',
                                    firstName: $this.customerNUFI.lastName,
                                    email: $this.customerNUFI.email,
                                    password: $this.customerNUFI.password,
                                    subscriptionId: subscriptionName,
                                    subscriptionKey: subscriptionKey
                                  }).then(suResponse => {
                                    $this.loading = false;
                                    if(suResponse.status === 200) {
                                      $this.message = 'Felicidades! estas subscrito a NuFi. Para activar tu cuenta revisa tu correo.';
                                    } else {
                                      $this.message = suResponse.data;
                                    }
                                  }).catch(() => {
                                    $this.loading = false;
                                    $this.message = 'Error al crear usuario en portal de NuFi';
                                  });
                                }                                
                              }).catch(()=> {
                                $this.loading = false;
                                $this.message = 'Error al crear cliente en Stripe';
                              });                              
                              // $this.message += '***Subscrpcion' + nsResponse.data.id;
                              //TODO Create stripe customer
                            } else {
                              $this.loading = false;
                              $this.message = 'Error al crear subscripcion';
                            }                            
                          }).catch(() => {
                            $this.loading = false;
                          });                          
                        }
                      }).catch(() => {
                        // eslint-disable-next-line no-debugger
                        debugger
                        $this.loading = false;
                        $this.message = "El usuario ya existe en NuFi.";
                      });
                    }
                  });                
              } else {
                $this.message = "Capcha error";
                $this.loading = false;
              }             
            }
          });          
        });
      });
    },
    subscribeWithTransfer() {
      const $this = this;
      this.loading = true;
      event.preventDefault();
      window.grecaptcha.ready(function() {        
        window.grecaptcha.execute('6LdLndkZAAAAAGdUjVOMNtsUsM3momBQkRR5yIbO', {action: 'submit'}).then(function(token) {          
          $this.$store.dispatch("verifyCapcha", {token}).then(response => {            
            if(response.status === 200) {
              const data = JSON.parse(response.data);
              if(data.success && data.score > .8) {                                
                $this.$store.dispatch("createNuFiCustomer", $this.customerNUFI).then(ncResponse => {
                  if(ncResponse.status === 200 || ncResponse.status === 201) {                          
                    // $this.message += '***Usuario NuFi' + ncResponse.data.id;
                    const subscriptionName = `NuFi2020-${new Date().getTime()}`;
                    $this.$store.dispatch("createNuFiSubscriptionSubmitted", {
                      userId:ncResponse.data.id,
                      name: subscriptionName}).then(nsResponse => {
                      if(nsResponse.status === 200 || nsResponse.status === 201) {                              
                        $this.$store.dispatch("createStripeCustomer", {
                          name: `${$this.customerNUFI.firstName} ${$this.customerNUFI.lastName}`,
                          email: $this.customerNUFI.email,
                          phone: $this.customerNUFI.phone,                                
                          metadata: {
                            subscriptionKey: subscriptionName,
                            iva: "0.16"
                          },
                        }).then(csResponse => {                                
                          if(csResponse.status === 200) {
                            $this.message = 'Muy bien. Hemos registrado tus datos y hemos enviado un correo. Un colaborador de NuFi se pondrá en contacto contigo';
                          }
                          $this.loading = false;
                        }).catch(()=> {
                          $this.loading = false;
                          $this.message = 'Error al crear cliente en Stripe';
                        });                              
                        // $this.message += '***Subscrpcion' + nsResponse.data.id;
                        //TODO Create stripe customer
                      } else {
                        $this.loading = false;
                        $this.message = 'Error al crear subscripcion';
                      }                            
                    }).catch(() => {
                      $this.loading = false;
                    });                          
                  }
                }).catch(() => {
                  $this.loading = false;
                  $this.message = "El usuario ya existe en NuFi.";
                });                   
              } else {
                $this.message = "Capcha error";
                $this.loading = false;
              }             
            }
          });          
        });
      });
    },
    subscribe() {
      this.message = null;
      this.$refs.form.validate();
      if(this.valid) {
        if(this.paymentMethod === 'card') {
          this.subscribeWithCard();
        } else {
          this.subscribeWithTransfer();
        }          
      }
      
    },
    reset () {
      // this.$refs.form.reset();
      this.paymentMethod = 'card';
      this.paymentMethodChange('card');      
      // this.customerNUFI.phone = "+52";
      this.customerNUFI = {
        firstName: "",
        lastName: "",
        phone: "+52",
        email: "",
        confirmation: "signup",
        password: null,
        note: ""
      };
    },
    paymentMethodChange(method) {
      if(method === 'card') { 
        this.$nextTick(() => {
          const elements = this.stripe.elements();
          this.cardElement = elements.create('card');
          this.cardElement.mount('#card-element');
        });        
      }      
    },
    ChangeLocale() {
      if(this.$i18n.locale === 'en') {
        this.$i18n.locale = 'es';
      } else {
        this.$i18n.locale = 'en';
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.ntitle {
  color:  #2032B0;
}
.right {
  float: right;  
}
.icontainer {
  padding-left: 20%;
  padding-right: 20%;
  padding-top: 10%;
}
.locale-btn {
  margin-left:70%;  
}
</style>